import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import NotFoundPage from './pages/NotFoundPage';
import RulesPage from './pages/RulesPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import JoinRedirectPage from './pages/JoinRedirectPage';
import BlogPage from './pages/BlogPage';
import GuidePage from './pages/GuidePage';
import PublicMetadata from './components/SEO/PublicMetadata';
import ProtectedAdminRoute from './components/admin/ProtectedAdminRoute';
import { AdminAuthProvider } from './contexts/AdminAuthContext';

import theme from './theme';
import './index.css';

const AdminLoginPage = lazy(() => import('./pages/admin/AdminLoginPage'));
const AdminDashboardPage = lazy(() => import('./pages/admin/AdminDashboardPage'));

const App: React.FC = () => {
  return (
    <StyledThemeProvider theme={theme}>
      <AdminAuthProvider>
        <Routes>
          {/* Admin routes - no Layout wrapper */}
          <Route path="/admin" element={<Suspense fallback={<p role="status">Loading administration…</p>}><AdminLoginPage /></Suspense>} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedAdminRoute>
                <Suspense fallback={<p role="status">Loading administration…</p>}><AdminDashboardPage /></Suspense>
              </ProtectedAdminRoute>
            }
          />
          
          {/* Public routes with Layout */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/rules" element={<Layout><RulesPage /></Layout>} />
          <Route path="/blog" element={<Layout><BlogPage /></Layout>} />
          <Route path="/blog/:slug" element={<Layout><GuidePage /></Layout>} />
          <Route path="/terms" element={<Layout><TermsPage /></Layout>} />
          <Route path="/privacy" element={<Layout><PrivacyPage /></Layout>} />
          <Route path="/join/:code" element={<Layout><JoinRedirectPage /></Layout>} />
          <Route path="*" element={<Layout><NotFoundPage /></Layout>} />
        </Routes>
        <PublicMetadata />
      </AdminAuthProvider>
    </StyledThemeProvider>
  );
};

export default App;
